/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { StringConfigOptions } from "./StringConfigOptions";
export const StringConfig = core.serialization.object({
    size: StringConfigOptions,
});
